// Formatting helpers + shared constants for AluminaOne Pro (Bahasa Indonesia, IDR)

export function formatRp(value) {
  const n = Number(value || 0);
  const rounded = Math.round(n);
  return 'Rp ' + rounded.toLocaleString('id-ID');
}

export function formatNumber(value) {
  return Number(value || 0).toLocaleString('id-ID');
}

// Safely extract a human-readable message from an Axios/FastAPI error.
// FastAPI 422 returns `detail` as an array of objects -> never render those directly.
export function getErrorMessage(err, fallback = 'Terjadi kesalahan. Coba lagi.') {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || fallback;
  if (typeof d === 'string') return d;
  if (Array.isArray(d)) {
    const msgs = d.map((x) => (typeof x === 'string' ? x : x?.msg)).filter(Boolean);
    return msgs.length ? msgs.join('. ') : fallback;
  }
  if (typeof d === 'object' && d.msg) return d.msg;
  return fallback;
}


export function parseRp(str) {
  if (typeof str !== 'string') return Number(str || 0);
  return Number(str.replace(/[^0-9]/g, '')) || 0;
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Agu', 'Sep', 'Okt', 'Nov', 'Des'];

export function formatDate(iso) {
  if (!iso) return '-';
  try {
    const d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
  } catch {
    return iso;
  }
}

export function todayISO() {
  return new Date().toISOString().slice(0, 10);
}

export function waLink(phone, text) {
  let p = (phone || '').replace(/[^0-9]/g, '');
  if (p.startsWith('0')) p = '62' + p.slice(1);
  const q = text ? `?text=${encodeURIComponent(text)}` : '';
  return `https://wa.me/${p}${q}`;
}

// ---- Constants ----
export const STAGES = ['Survey', 'Penawaran', 'DP Diterima', 'Produksi', 'Pemasangan', 'Selesai'];

export const STAGE_STYLE = {
  'Survey': 'bg-sky-50 text-sky-800 border-sky-200',
  'Penawaran': 'bg-teal-50 text-teal-800 border-teal-200',
  'DP Diterima': 'bg-emerald-50 text-emerald-800 border-emerald-200',
  'Produksi': 'bg-amber-50 text-amber-900 border-amber-200',
  'Pemasangan': 'bg-orange-50 text-orange-900 border-orange-200',
  'Selesai': 'bg-green-50 text-green-800 border-green-200',
};

export const STAGE_DOT = {
  'Survey': 'bg-sky-500',
  'Penawaran': 'bg-teal-500',
  'DP Diterima': 'bg-emerald-500',
  'Produksi': 'bg-amber-500',
  'Pemasangan': 'bg-orange-500',
  'Selesai': 'bg-green-600',
};

export const PAYMENT_STYLE = {
  'Lunas': 'bg-emerald-50 text-emerald-800 border-emerald-200',
  'Belum lunas': 'bg-orange-50 text-orange-900 border-orange-200',
  'Tertunggak': 'bg-red-50 text-red-800 border-red-200',
};

export const LEAD_STATUSES = ['Baru', 'Survey', 'Penawaran Terkirim', 'Deal', 'Batal'];
export const LEAD_STATUS_STYLE = {
  'Baru': 'bg-sky-50 text-sky-800 border-sky-200',
  'Survey': 'bg-amber-50 text-amber-900 border-amber-200',
  'Penawaran Terkirim': 'bg-teal-50 text-teal-800 border-teal-200',
  'Deal': 'bg-emerald-50 text-emerald-800 border-emerald-200',
  'Batal': 'bg-red-50 text-red-800 border-red-200',
};

export const QUOTE_STATUSES = ['Draft', 'Terkirim', 'Disetujui', 'Ditolak'];
export const QUOTE_STATUS_STYLE = {
  'Draft': 'bg-slate-100 text-slate-700 border-slate-200',
  'Terkirim': 'bg-sky-50 text-sky-800 border-sky-200',
  'Disetujui': 'bg-emerald-50 text-emerald-800 border-emerald-200',
  'Ditolak': 'bg-red-50 text-red-800 border-red-200',
};

export const SUMBER_OPTIONS = ['WhatsApp', 'Walk-in', 'Referral', 'Instagram', 'Lainnya'];
export const KATEGORI = [
  { value: 'profil', label: 'Profil Aluminum' },
  { value: 'kaca', label: 'Kaca' },
  { value: 'aksesoris', label: 'Aksesoris & Bahan' },
  { value: 'ongkos', label: 'Ongkos Kerja' },
];
export const KATEGORI_LABEL = { profil: 'Profil Aluminum', kaca: 'Kaca', aksesoris: 'Aksesoris & Bahan', ongkos: 'Ongkos Kerja' };
export const SATUAN_OPTIONS = ['batang', 'm2', 'meter', 'pcs', 'set', 'unit', 'tube', 'lembar'];
export const METODE_OPTIONS = ['transfer', 'cash', 'qris'];
export const TIPE_OPTIONS = [
  { value: 'dp', label: 'DP (Uang Muka)' },
  { value: 'progress', label: 'Progress' },
  { value: 'pelunasan', label: 'Pelunasan' },
];
